module.exports = __webpack_public_path__ + "img/external.c72fc740.svg";